import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ShareModalState {
    involvedUsers: object;
}

const initialState: ShareModalState = {
    involvedUsers: {}
}


const shareModalSlice = createSlice({
    name: 'shareModal',
    initialState,
    reducers: {
        shareModalAddInvolvedUser: (state, action: PayloadAction<any>) => {
            state.involvedUsers[action.payload.id] = action.payload;
        },
        shareModalRemoveInvolvedUser: (state, action: PayloadAction<string>) => {
            delete state.involvedUsers[action.payload];
        },
        shareModalUpdateRoleInvolvedUser: (state, action: PayloadAction<any>) => {
            state.involvedUsers[action.payload[0]].role = action.payload[1];
        },
        shareModalChangeHasAccess: (state, action: PayloadAction<any>) => {
            state.involvedUsers[action.payload[0]].hasAccess = action.payload[1];
        }
    }
})

export const {shareModalAddInvolvedUser, shareModalRemoveInvolvedUser, shareModalUpdateRoleInvolvedUser, shareModalChangeHasAccess} = shareModalSlice.actions;

export default shareModalSlice.reducer;